// extracted by mini-css-extract-plugin
export var deleteModal = "_hd-0";